import { Heading, LiliCheckbox, LiliCheckboxSize } from '@lili/lili-frontend-common';
import React from 'react';
import { ControllerWrapper } from '../../../../../hooks/providers/ControllerWrapper';
import { ExtendedUseFormReturn } from '../../../../../hooks/providers/useFormHooks';
import { InviteFormType } from '../InviteFormStep';

export enum InviteFormTermsType {
  ADMIN_CORPORATE_RESOLUTION = 'ADMIN_CORPORATE_RESOLUTION',
  APPOINT_ADMIN = 'APPOINT_ADMIN',
  ACCOUNTANT_VIEWER_TERMS = 'ACCOUNTANT_VIEWER_TERMS',
}

interface InviteTermsCheckboxProps {
  formMethods: ExtendedUseFormReturn<InviteFormType>;
  onTermsClick: (type: InviteFormTermsType) => void;
  type: InviteFormTermsType;
  title: string;
  linkText: string;
}

export const InviteTermsCheckbox = ({ onTermsClick, type, title, linkText, formMethods }: InviteTermsCheckboxProps) => (
  <div className='flex items-center gap-[6px]'>
    <ControllerWrapper name={type} control={formMethods.control}>
      {({ onChange, value }) => (
        <LiliCheckbox
          id={type}
          checked={value}
          onCheckedChange={onChange}
          size={LiliCheckboxSize.MEDIUM}
          containerClassName='w-[20px] h-[20px]'
        />
      )}
    </ControllerWrapper>
    <Heading.H9 className='mt-[2px] inline'>
      {title}
      <button
        type='button'
        onClick={() => onTermsClick(type)}
        id='triggerTerms'
        className='font-metricR text-[16px] text-bw06 underline ml-[4px] inline hover:cursor-pointer'
      >
        {linkText}
      </button>
    </Heading.H9>
  </div>
);
